/* eslint-disable */
/* istanbul ignore next */
/**
 * 滑动价格选择器
 */
define('widget/price-sliderbar', ['jquery', '/dist/vendor/dist/css.js!/dist/css/widget/price-sliderbar-334926df.css'], ($) => {
    function render(option) {
        return `<ul class="price-adjustment">
            <li class="notice-msg"><div class="right adjust-price-wrap js-adjustPriceWrap"><span class="adjust-price"><span class="js-adjustPrice">${Number(option.price * option.discount).toFixed(2)}</span><span class="wan">万</span></span></div></li>
            <li class="slidebar">
                <div class="scale-panel">
                    <div class="scale bar">
                        <div class="step"><img src="/dist/images/slidebar-80ed3961.png" class="slide-btn" /></div>
                    </div>
                    <div>
                        <span class="low-price">
                            <span class="price-line">|<br/></span>${option.lowPrice}万
                        </span>
                        <span class="center-price">
                            <span class="price-line">|<br/></span>
                            <span class="center-price-info">${option.centerPrice}万</span>
                        </span>
                        <span class="car-price">
                            <span class="price-line">|<br/></span>
                            <span class="car-price-txt">车主报价</span>
                            <span class="car-price-info">${option.price}万</span>
                        </span>
                    </div>
                </div>
            </li>
        </ul>`;
    }

    /* istanbul ignore next */
    /**
    * 初始化操作
    * @selector 要显示价格选择器的页面元素
    * @option 动态配置的参数, (showNoticeMsg: 是否显示降价通知我 discount: 默认降价折扣率, onInit: 初始化的回调函数, onDrag: 滑动的回调函数, onDragEnd: 滑动结束的回调)
    */
    function init(selector, option = {}) {
        option = $.extend({ showNoticeMsg: true, discount: 1, }, option);
        const LOWDISCOUNT = 0.7; // 滑动条滑动到最左边最低折扣率7折
        const salePrice = Number(option.price); //车主报价
        let noticePrice = salePrice;
        const ndLayout = $(selector); // 最外层
        option.lowPrice = (option.price * LOWDISCOUNT).toFixed(2); // 滑动条左侧最低价格
        option.centerPrice = (option.price * (1 + LOWDISCOUNT) / 2).toFixed(2);
        ndLayout.html(render(option)); // 将代码结构渲染到页面
        const ndSlideBtn = ndLayout.find('.slide-btn'); // 可滑动的按钮
        const ndSlideContainer = ndLayout.find('.bar'); // 可滑动的区域
        const ndPercentage = ndSlideContainer.find('.step'); // 表示当前进度
        const ndJsAdjustPrice = ndLayout.find('.js-adjustPrice'); // 显示计算出的价格
        const ndDesc = ndLayout.find('.desc'); // 提示语
        const ndJsAdjustPriceWrap = ndLayout.find('.js-adjustPriceWrap'); //通知我
        const barWidth = ndSlideContainer.width(); // 能拖动的区域总宽度

        if (!option.showNoticeMsg) {
            ndLayout.find('.notice-msg').hide();
        }

        noticePrice = (noticePrice * option.discount).toFixed(2);
        const defautPos = (1 - (salePrice - noticePrice) / ((1 - LOWDISCOUNT) * salePrice)); // 计算默认拖动按钮的位置
        ndJsAdjustPriceWrap.css('right', 0);
        ndPercentage.css('width', 0).animate({ width: '100%' }, 1000).animate({ width: `${barWidth * defautPos}px` }, 1000);
        // 屏蔽页面元素的默认拖动事件，否则按钮会拖动图片动
        document.ondragstart = function() {
            return false;
        };
        ndSlideBtn.on('mousedown', function (ev) {
            ev.stopPropagation();
            const clientX = ev.clientX;
            const noticeWdith = ndJsAdjustPriceWrap.width(); // 通知我的宽度
            const btnWidth = ndSlideBtn.width(); // 拖动按钮宽度
            const stepWidth = ndPercentage.width();
            $(document).on('mousemove', function (e) {
                e.stopPropagation();
                let stepNewWidth = stepWidth + e.clientX - clientX; // 这个就是蓝条滑动后的宽度
                if (stepNewWidth > barWidth) {
                    stepNewWidth = barWidth;
                } else if (stepNewWidth < 0) {
                    stepNewWidth = 0;
                }
                const progress = Math.round(stepNewWidth / barWidth * 100); //滑动距离占整体滑动区域长度的百分比
                updateDom(stepNewWidth, noticeWdith, progress);
                if (option.onDrag) {
                    const json = {
                        price: noticePrice,
                        progress,
                    };
                    option.onDrag(json);
                }
                return false;
            });
            $(document).on('mouseup', function() {
                $(this).off('mousemove');
                option.onDragEnd && option.onDragEnd();
            }); // eslint-disable-line
        });
        if (option.onInit) {
            const json = {
                price: noticePrice,
                progress: option.defautPos,
            };
            option.onInit(json);
        }

        // 更新dom显示
        function updateDom(stepNewWidth, noticeWdith, progress) {
            ndPercentage.width(stepNewWidth);
            if (barWidth >= noticeWdith + stepNewWidth) { // 总滑动长度大于蓝条和通知我的宽度,则移动通知我的right值
                ndJsAdjustPriceWrap.css('right', `${barWidth - noticeWdith - stepNewWidth + 22}px`);
            } else {
                ndJsAdjustPriceWrap.css('right', '0px');
            }
            noticePrice = (salePrice * LOWDISCOUNT + salePrice * (1 - LOWDISCOUNT) * progress / 100).toFixed(2); // 滑动条范围从7折到车主报价
            ndJsAdjustPrice.html(noticePrice);
        }
    }

    return { render, init };
});
